import {
    UP_DEV,
    UP_DEV_VALUE,
    UP_EXPERIMENT,
    UP_EXPERIMENT_IS_ENABLED,
    UP_EXPERIMENT_OPTIONS,
    UP_EXPERIMENT_VARIANT,
} from 'constants/urlParams';

export type AbAutoTestsQuery = {
    aqa: boolean | null;
    experiment: string | null;
    variantName: string | null;
    experimentOptions: string | null;
    isEnabled: string | null;
};

export const getAbAutoTestsQuery = (search: string = window.location.search): AbAutoTestsQuery => {
    const searchParams = new URLSearchParams(search);

    return {
        aqa: searchParams.get(UP_DEV) === UP_DEV_VALUE,
        experiment: searchParams.get(UP_EXPERIMENT),
        variantName: searchParams.get(UP_EXPERIMENT_VARIANT),
        experimentOptions: searchParams.get(UP_EXPERIMENT_OPTIONS),
        isEnabled: searchParams.get(UP_EXPERIMENT_IS_ENABLED),
    } as const;
};
